const formatDate = (datetime: string) => {
  return new Date(datetime).toLocaleString();
};

export default formatDate;
